import Janus from '../external/janus.es'
import { sipPluginSession } from './sippluginsession.js';
import { Machine, assign, interpret, send, forwardTo } from 'xstate' // global variable: window.XState
import md5 from 'md5'
import { CallStatusErrorCode } from './errorCodes'
import { choose } from 'xstate/lib/actions';

var endpointView;

export class CallView {
    // private
    uiCallbacks = {};
    instanceId = undefined;
    referInstanceId = undefined;	// the call instanceId that performs REFER dial
    sipserver = undefined;
    username = undefined;
    localStream = undefined;
    remoteStream = undefined;
    pbxPlatform = undefined;


    //public
    direction = undefined; // incoming; outgoing
    state = 'idle'; // idle; incomingCall; connected; reconnected; callingOut; ringingOut; progressOut; hold; transferring
    stateDesc = undefined;
    statusErrorCode = undefined
    statusErrorDescription = undefined;
    peerUsername = undefined;
    peerDisplay = undefined;
    lastCallerUsername = undefined;
    lastCallerDisplay = undefined;
    lastCalleeUsername = undefined;
    lastCalleeDisplay = undefined;
    localStreamActive = false;
    remoteStreamActive = false;
    videoRequested = false;
    videoSource = undefined;

    lastHangupCode = undefined;
    lastHangupReason = undefined;
    lastHangupTone = undefined;	// undefined, busy, reorder, nu
    lastDirection = undefined;
    canPlayBusyTone = false;
    canPlayReorderTone = false;
    canPlayNuTone = false;
    stats = undefined;
    isSlowAudioDownlink = false;
    isSlowAudioUplink = false;

    // private
    lineRegistered = false;
    callId = undefined;
    xferInstanceId = undefined;
    answerRequested = false;
    slowAudioUplinkTimer = undefined;
    slowAudioDownlinkTimer = undefined;

    // public caps
    canMakeCall = false;
    canHangup = false;
    canAnswer = false;
    canRingOut = false;
    featureHoldResume = true;
    canHold = false;
    canResume = false;
    canBlindXfer = false;
    canXfer = false;
    canSendDtmf = false;
    isMuted = false;
    hasLocalAudio = false;
    hasRemoteAudio = false;
    hasLocalVideo = false;
    hasRemoteVideo = false;
    enabledVideoSource = undefined;

    ToDialUri(userpart) {
        let dialUri = userpart;
        if (userpart.indexOf("sip:") < 0 && userpart.indexOf("@") < 0) {
            dialUri = this.sipserver.slice(0, 4) + userpart + "@" + this.sipserver.slice(4);
        }
        return dialUri;
    }


    //////////////////////////////////////////
    // public UI commands
    //////////////////////////////////////////
    doMakeCall(target) {
        this.clearError()
        if (!this.canMakeCall) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_MAKE_CALL, "Unable to make call: line busy"), 0);
            return;
        }
        if (target.length === 0) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_MAKE_CALL, "Unable to make call: target empty"), 0);
            return;
        }
        try {
            let targetUri = this.ToDialUri(target);
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_MAKE_CALL',
                    target: targetUri,
                    referId: "",
                    instanceId: this.instanceId
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_MAKE_CALL, "Unable to make call: " + err.message), 0);
            return;
        }
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    doAnswer() {
        this.clearError()
        Janus.log("Answering call on instance ID: ", this.instanceId);
        if (this.answerRequested) {
            Janus.log("Answer already requested");
            return;
        }
        if (!this.canAnswer) {
            Janus.log("Unabled to answer, instance ID: ", this.instanceId);
            // setTimeout(() => this.onCallStatusError("Unable to answer"), 0);
            return;
        }
        try {
            JanusAnswerCall(this.instanceId);
            this.answerRequested = true;
        } catch (err) {
            Janus.log("Unabled to answer:", err.message);
            // setTimeout(() => this.onCallStatusError("Unable to answer call: " + err.message), 0);
        }
    }
    doHangup() {
        this.clearError()
        try {
            JanusHangupCall(this.instanceId);
            this.canHangup = false;
            this.canMakeCall = false;
            this.canAnswer = false;
            this.canRingOut = false;
            this.canHold = false;
            this.canResume = false;
            this.canBlindXfer = false;
            this.canXfer = false;
            this.canSendDtmf = false;
            this.isMuted = false;
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_HANG_UP, "Unable to hangup call: " + err.message), 0);
            return;
        }
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    doIceRestart() {
        Janus.log('ICE Restart requested');
        sessionService.send({
            type: 'FORWARD_TO_PLUGIN',
            event: {
                type: 'DO_ICE_RESTART',
                instanceId: this.instanceId
            }
        });
    }
    doHold() {
        this.clearError()
        if (!this.canHold) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_HOLD, "Unable to hold"), 0);
            return;
        }
        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_HOLD',
                    instanceId: this.instanceId
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_HOLD, "Unable to hold call: " + err.message), 0);
            return;
        }
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    doResume() {
        this.clearError()
        if (!this.canResume) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_RESUME, "Unable to resume"), 0);
            return;
        }
        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_RESUME',
                    instanceId: this.instanceId
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_RESUME, "Unable to resume call: " + err.message), 0);
            return;
        }
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    doBlindXfer(refer_to) {
        this.clearError()
        if (!this.canBlindXfer || !refer_to) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to blind transfer"), 0);
            return;
        }
        try {
            let sip_refer_to = sessionService.state.context.sipserver.replace("sip:", "sip:" + refer_to + "@");
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_BLIND_XFER',
                    instanceId: this.instanceId,
                    refer_to: sip_refer_to
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to blind transfer call: " + err.message), 0);
            return;
        }
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    doXfer() {
        this.clearError()
        if (!this.canXfer || this.xferInstanceId === undefined) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to complete transfer"), 0);
            return;
        }
        try {
            JanusCompleteTransfer(this.xferInstanceId);
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to complete transfer: " + err.message), 0);
            return;
        }
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    doSendDtmf(digit) {
        this.clearError()
        if (!this.canSendDtmf) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_DTMF, "Unable to send DTMF"), 0);
            return;
        }

        if (!digit.match(/^[0-9*#]$/)) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_DTMF, "Unable to send DTMF: invalid dtmf value:[" + digit + "]"), 0);
            return;
        }

        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_SEND_DTMF',
                    instanceId: this.instanceId,
                    dtmf: digit
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_DTMF, "Unable to send dtmf: [" + digit + "], " + err.message), 0);
        }
    }
    doEnableVideo(doVideo, videoSource = undefined) {
        this.clearError()
        Janus.log("Video requested: ", doVideo);
        this.videoRequested = doVideo;
        this.videoSource = videoSource
        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_ENABLE_VIDEO',
                    doVideo: doVideo,
                    videoSource: videoSource,
                    instanceId: this.instanceId
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_VIDEO, "Unable to enable video " + err.message), 0);
        }
    }
    doGetStats() {
        this.clearError()
        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_GET_STATS',
                    instanceId: this.instanceId
                }
            });
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_STATS, "Unable to get statistics " + err.message), 0);
        }
    }
    doMuteMicrophone(mute) {
        try {
            Janus.log('Mute microphone requested:', mute, ', local stream:', this.localStream)
            const tracks = this.localStream && this.localStream.getAudioTracks();
            if (tracks == null) {
                Janus.warn('no local audio tracks to mute microphone')
                return;
            }

            for (let track of tracks) {
                track.enabled = !mute;
            }

            this.onCallStatusChange()
            if (typeof this.uiCallbacks.onCallStatusChange === 'function') {
                this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
            }
        } catch (err) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_AUDIO, 'Unable to mute/unmute microphone ' + err.message), 0);
        }
    }
    clearError() {
        this.statusErrorCode = undefined
        this.statusErrorDescription = undefined
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }

    //////////////////////////////////////////
    // callbacks
    //////////////////////////////////////////
    onLineRegistered() {
        this.lineRegistered = true;
        this.onCallStatusChange();
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    onLineUnregistered() {
        this.lineRegistered = false;
        this.onCallStatusChange();
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    onCallStatusError(errorCode, errorMessage) {
        this.statusErrorCode = errorCode;
        this.statusErrorDescription = errorMessage;
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username, errorMessage);
    }
    onLocalStream(stream, isActive) {
        this.localStream = isActive ? stream : undefined;
        this.localStreamActive = isActive;
        if (this.localStream) {
            const videoTrack = this.localStream.getVideoTracks()[0]
            // do this.doEnableVideo(false) BS for none-SR calls only as it severly intefers with SR restart process
            if (this.SetupCallCaps.instanceId < 4 && videoTrack && videoTrack.readyState === 'live' && videoTrack.onended == null) {
                videoTrack.onended = () => {
                    Janus.log('Video track ended. Updating statemachine to video disabled')
                    this.doEnableVideo(false)
                }
            }
        }

        this.onCallStatusChange();
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onMediaStatusChange(this.sipserver, this.username);
    }
    onRemoteStream(stream, isActive) {
        this.remoteStream = isActive ? stream : undefined;
        this.remoteStreamActive = isActive;
        this.onCallStatusChange();
        if (typeof this.uiCallbacks.onMediaStatusChange === "function")
            this.uiCallbacks.onMediaStatusChange(this.sipserver, this.username);
    }
    onStatsUpdated(stats) {
        this.stats = stats;
        if (typeof this.uiCallbacks.onStatsUpdated === "function")
            this.uiCallbacks.onStatsUpdated(stats);
    }

    onSlowLink(uplink, media, lost) {
        // Janus reports the direction of uplink wrong
        if (media == "audio" && !uplink && typeof this.uiCallbacks.onSlowAudioUpLink === "function") {
            if (this.slowAudioUplinkTimer) clearTimeout(this.slowAudioUplinkTimer);
            this.slowAudioUplinkTimer = undefined;
            this.isSlowAudioUplink = true;
            this.uiCallbacks.onSlowAudioUpLink(true);
            this.slowAudioUplinkTimer = setTimeout(() => {
                this.isSlowAudioUplink = false;
                this.uiCallbacks.onSlowAudioUpLink(false)
            }, 4000);
        } else if (media == "audio" && uplink && typeof this.uiCallbacks.onSlowAudioDownLink === "function") {
            if (this.slowAudioDownlinkTimer) clearTimeout(this.slowAudioDownlinkTimer);
            this.slowAudioDownlinkTimer = undefined;
            this.isSlowAudioDownlink = true;
            this.uiCallbacks.onSlowAudioDownLink(true);
            this.slowAudioDownlinkTimer = setTimeout(() => {
                this.isSlowAudioDownlink = false;
                this.uiCallbacks.onSlowAudioDownLink(false)
            }, 4000);
        }
    }


    onCallStatusIdle(code, reason) {
        this.lastHangupCode = code;
        this.lastHangupReason = reason;
        this.lastHangupTone = undefined;
        this.canPlayBusyTone = false;
        this.canPlayReorderTone = false;
        this.canPlayNuTone = false;
        if (this.slowAudioDownlinkTimer) clearTimeout(this.slowAudioDownlinkTimer);
        if (this.slowAudioUplinkTimer) clearTimeout(this.slowAudioUplinkTimer);
        this.slowAudioDownlinkTimer = undefined;
        this.slowAudioUplinkTimer = undefined;
        this.isSlowAudioUplink = false;
        this.isSlowAudioDownlink = false;
        this.hasLocalAudio = false;
        this.hasRemoteAudio = false;
        this.hasLocalVideo = false;
        this.hasRemoteAudio = false;
        this.enabledVideoSource = undefined;
        // do this.doEnableVideo(false) BS for none-SR calls only as it severly intefers with SR restart process
        if (this.instanceId < 3) this.doEnableVideo(false);

        if (code && (this.direction === 'outgoing' || this.state === 'connected' || this.state === 'reconnected')) {
            if (code === 404) {
                this.lastHangupTone = 'nu';
                this.canPlayNuTone = true;
            } else if (code == 486) {
                this.lastHangupTone = 'busy';
                this.canPlayBusyTone = true;
            } else if (code > 0) {
                this.lastHangupTone = 'reorder';
                this.canPlayReorderTone = true;
            }
        }
    }

    onCallStatusDeepIdle() {
        this.canPlayBusyTone = false;
        this.canPlayReorderTone = false;
        this.canPlayNuTone = false;
    }


    onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
        let oldState = this.state;
        this.state = callState ? callState : oldState;
        if (callState) {
            if (this.state === 'idle') {
                // going idle
                this.lastDirection = this.direction;
                this.direction = undefined;
                this.callId = undefined;
                this.referInstanceId = undefined;
                this.localStreamActive = false;
                this.remoteStreamActive = false;
                this.localStream = undefined;
                this.remoteStream = undefined;
                if (this.lastDirection === 'incoming') {
                    this.lastCallerUsername = this.peerUsername;
                    this.lastCallerDisplay = this.peerDisplay;
                }
                if (this.lastDirection === 'outgoing') {
                    this.lastCalleeUsername = this.peerUsername;
                    this.lastCalleeDisplay = this.peerDisplay;
                }
                this.peerUsername = undefined;
                this.peerDisplay = undefined;
                this.answerRequested = false;
            } else if (oldState === 'idle') {
                // going non-idle
                this.direction = (callState === 'incomingcall' || callState === 'incomingcallReplaces' || callState === 'connected') ? 'incoming' : 'outgoing';
                this.stateDesc = undefined;
                this.statusErrorCode = undefined;
                this.statusErrorDescription = undefined;
                this.lastHangupCode = undefined;
                this.lastHangupReason = undefined;
                this.lastHangupTone = undefined;
                this.canPlayBusyTone = false;
                this.canPlayReorderTone = false;
                this.canPlayNuTone = false;

            }
        }
        this.stateDesc = callStateDesc;
        if (remoteUri && remoteUri.indexOf("sip:") >= 0) {
            this.peerUsername = remoteUri.indexOf("@") < 0 ? "anonymous" : remoteUri.substring(remoteUri.indexOf("sip:") + 4, remoteUri.indexOf("@"));
        } else if (remoteUri) {
            this.peerUsername = remoteUri;
        }
        if (remoteDisplay) this.peerDisplay = remoteDisplay;

        this.SetupCallCaps();
        try {
            this.isMuted = this.localStreamActive && this.localStream != null && !this.localStream.getAudioTracks()[0].enabled;
        } catch (err) {
            Janus.warn('unable to determine isMuted state', err)
            this.isMuted = false;
        }
        if (media_caps) {
            if (this.hasLocalAudio !== media_caps.hasLocalAudio ||
                this.hasRemoteAudio !== media_caps.hasRemoteAudio ||
                this.hasLocalVideo !== media_caps.hasLocalVideo ||
                this.hasRemoteVideo !== media_caps.hasRemoteVideo ||
                this.enabledVideoSource !== media_caps.enabledVideoSource) {

                Janus.log('Media caps change:\n',
                    '    local audio: [', this.hasLocalAudio, '] --> [', media_caps.hasLocalAudio, ']\n',
                    '   remote audio: [', this.hasRemoteAudio, '] --> [', media_caps.hasRemoteAudio, ']\n',
                    '    local video: [', this.hasLocalVideo, '] --> [', media_caps.hasLocalVideo, ']\n',
                    '   remote video: [', this.hasRemoteVideo, '] --> [', media_caps.hasRemoteVideo, ']\n',
                    '   video source: [', this.enabledVideoSource, '] --> [', media_caps.enabledVideoSource, ']\n'
                );

            }
            this.hasLocalAudio = media_caps.hasLocalAudio;
            this.hasRemoteAudio = media_caps.hasRemoteAudio;
            this.hasLocalVideo = media_caps.hasLocalVideo;
            this.hasRemoteVideo = media_caps.hasRemoteVideo;
            this.enabledVideoSource = media_caps.enabledVideoSource;
        }
    }

    SetupCallCaps() {
        this.canMakeCall = this.lineRegistered && this.state === 'idle';
        this.canHangup = this.state !== 'idle';
        this.canAnswer = this.state === 'incomingcall' || this.state === 'incomingcallReplaces';
        this.canRingOut = this.state === 'ringingOut';
        // this.featureHoldResume = this.pbxPlatform !== 'cucm'
        this.canHold = this.featureHoldResume && (this.state === 'connected' || this.state === 'reconnected');
        this.canResume = this.featureHoldResume && this.state === 'hold';
        this.canBlindXfer = this.pbxPlatform !== 'cucm' && (this.state === 'hold');
        this.canSendDtmf = this.remoteStreamActive && (this.state === 'connected' || this.state === 'reconnected');
    }
}

export class SrCallView extends CallView {
    // private
    srRequested = false;
    srTarget = undefined;
    srFrameRate = undefined;

    doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight) {
        if (!this.srTarget) {
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_SCREEN_RECORDING, "Unable to start screen recording (no target)"), 0);
            return;
        }
        this.srRequested = true;
        super.doEnableVideo(true, 'screen');
        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_START_SR',
                    instanceId: this.instanceId,
                    callId: callId,
                    frameRate: frameRate === undefined? this.srFrameRate : frameRate,
                    screenWidth: screenWidth,
                    screenHeight: screenHeight,
                    target: this.ToDialUri(target ? target : this.srTarget)
                }
            });
        } catch (err) {
            Janus.error('Unable to start screen recording', err)
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_SCREEN_RECORDING, "Unable to start screen recording: " + err.message), 0);
        }
    }

    doStopScreenRecording() {
        this.srRequested = false;
        try {
            sessionService.send({
                type: 'FORWARD_TO_PLUGIN',
                event: {
                    type: 'DO_STOP_SR',
                    instanceId: this.instanceId,
                }
            });
        } catch (err) {
            Janus.error('Unable to stop screen recording', err)
            setTimeout(() => this.onCallStatusError(CallStatusErrorCode.ERROR_SCREEN_RECORDING, "Unable to start screen recording: " + err.message), 0);
        }        
    }

    onLineRegistered() {
        Janus.log('SR call: line registered');
        super.onLineRegistered();
    }
    onLineUnregistered() {
        Janus.log('SR call: line unregistered');
        super.onLineUnregistered();
    }
    onCallStatusError(errorCode, errorMessage) {
    }
    onLocalStream(stream, isActive) {
    }
    onRemoteStream(stream, isActive) {
    }
    onStatsUpdated(stats) {
    }


    SetupCallCaps() {
        this.canMakeCall = this.lineRegistered && this.state === 'idle';
        this.canHangup = this.state !== 'idle';
        this.canAnswer = false;
        this.canRingOut = this.state === 'ringingOut';
        this.featureHoldResume = false;
        this.canHold = false;
        this.canResume = false;
        this.canBlindXfer = false;
        this.canSendDtmf = false;
    }



}

export class SmCallView extends CallView {

    SetupCallCaps() {
        this.canMakeCall = this.lineRegistered && this.state === 'idle';
        this.canHangup = this.state !== 'idle';
        this.canAnswer = false;
        this.canRingOut = false;
        this.featureHoldResume = false;
        this.canHold = false;
        this.canResume = false;
        this.canBlindXfer = false;
        this.canSendDtmf = false;
    }

    onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
        let oldState = this.state;
        super.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
        if (oldState != this.state && this.state === 'incomingcall' && !this.answerRequested) {
            try {
                JanusAnswerCall(this.instanceId);
                this.answerRequested = true;
            } catch (err) {
                Janus.warn("Unabled to answer:", err.message);
                super.doHangup();
            }    
        } else if (this.state === 'incomingcall' || this.state === 'connected' ||  this.direction === 'outgoing' || this.state === 'idle') {
            // nothing
        }
        else {
            Janus.warn("Invalid SM call state [", this.state , "] hanging up");
            super.doHangup();
        }
    }
}


export class LineView {
    // private
    uiCallbacks = null;
    sipserver = undefined;
    username = undefined;
    displayName = undefined;
    secret = undefined;
    is_ha1_secret = false;
    bgCalls = undefined;
    autoregister = false;
    pbxPlatform = undefined;
    srCall = undefined;
    srRequested = false;
    srTarget = undefined;
    canSrStart = false;
    canSrStop = false;

    // public
    calls = undefined;
    callIndex = 0;					// call focus
    registerStatus = 'unregistered'; // registered, unregistered, registering, unregistering
    registerStatusError = undefined; // render error message if any
    mwiStatus = undefined;			// undefined, true/false

    // public caps
    canRequestRegister = false;
    canRequestUnregister = false;
    canToogle = false;



    //////////////////////////////////////////
    // public UI commands
    //////////////////////////////////////////
    doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight) {
        this.srRequested = true;
        this.canSrStart = !this.srRequested;
        this.canSrStop = this.srRequested;        
        Janus.log("Requested to start screen recording to target [", target, "]");
        if (this.srCall) {
            this.srCall.doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight);
        }
    }

    doStopScreenRecording() {
        this.srRequested = false;
        this.canSrStart = !this.srRequested;
        this.canSrStop = this.srRequested;
        Janus.log("Requested to stop screen recording");
        if (this.srCall) this.srCall.doStopScreenRecording();
    }

    doRequestRegister() {
        if (!this.canRequestRegister || this.autoregister) {
            setTimeout(() => this.onLineRequestRegisterFailed("Cannot request register "), 0);
            return;
        }
        this.canRequestRegister = false;
        this.canRequestUnregister = false;
        try {
            JanusActivateSipRegistration(true, this.sipserver, this.username, this.secret, this.is_ha1_secret, this.displayName, this.smTarget);
            this.canRequestUnregister = true;
            setTimeout(() => this.onLineRegisterRequested(), 0);
        } catch (error) {
            this.canRequestRegister = true;
            setTimeout(() => this.onLineRequestRegisterFailed(error.message), 0);
        }
    }

    doRequestUnregister() {
        if (!this.canRequestUnregister || this.autoregister) {
            setTimeout(() => this.onLineRequestUnregisterFailed("Cannot request unregister "), 0);
            return;
        }
        this.canRequestRegister = false;
        this.canRequestUnregister = false;
        try {
            JanusDeactivateSipRegistration(false);
            this.canRequestRegister = true;
            setTimeout(() => this.onLineUnregisterRequested(), 0);
        } catch (error) {
            this.canRequestUnregister = true;
            setTimeout(() => this.onLineRequestUnregisterFailed(error.message), 0);
        }
    }

    doToogle() {
        if (!this.canToogle) {
            setTimeout(() => this.onCallStatusError(this.callIndex, CallStatusErrorCode.ERROR_TOGGLE_CALL, "Unable to alternate call"), 0);
            return;
        }

        try {
            if (this.calls[this.callIndex].state !== 'hold') {
                sessionService.send({
                    type: 'FORWARD_TO_PLUGIN',
                    event: {
                        type: 'DO_HOLD',
                        instanceId: this.calls[this.callIndex].instanceId
                    }
                });
            }

            this.callIndex = this.callIndex === 0 ? 1 : 0;
            setTimeout(() => this.onCallStatusChange(this.callIndex), 0);
        } catch (error) {
            setTimeout(() => this.onCallStatusError(this.callIndex, CallStatusErrorCode.ERROR_TOGGLE_CALL, "Unable to alternate call:" + error.message), 0);
        }
    }

    doMaintainCallFocus() {
        let activeCallIndex = this.calls.findIndex(call => ((call.state === 'connected' || call.state === 'reconnected') && call.referInstanceId !== this.callIndex));
        Janus.log('Index of active call=', activeCallIndex, ', current call index=', this.callIndex)
        if (activeCallIndex >= 0 & activeCallIndex != this.callIndex) {
            // make sure the current call is sent on hold (best effort)			
            try {
                if (this.calls[this.callIndex].state !== 'hold') {
                    sessionService.send({
                        type: 'FORWARD_TO_PLUGIN',
                        event: {
                            type: 'DO_HOLD',
                            instanceId: this.calls[this.callIndex].instanceId
                        }
                    });
                }

                this.callIndex = this.callIndex === 0 ? 1 : 0;
            } catch (error) {
                // fail fast
                Janus.error('Unable to hold call with index', this.callIndex, 'hanging up the call');
                setTimeout(() => this.calls[this.callIndex].doHangup());
            }
        }
    }



    ///////////////////////////////////////////
    // callbacks
    ///////////////////////////////////////////
    onEndpointReconnecting() {
        this.canRequestRegister = false;
        this.canRequestUnregister = false;
        this.canToogle = false;
        this.onUnregistered();
    }

    onEndpointConnected() {
        this.canRequestRegister = !this.autoregister;
        this.canRequestUnregister = false;
    }
    onLineRequestRegisterFailed(message) {
        if (typeof this.uiCallbacks.onLineRequestegisterFailed === "function")
            this.uiCallbacks.onLineRequestRegisterFailed(message, this.sipserver, this.username);
    }
    onLineRequestUnregisterFailed(message) {
        if (typeof this.uiCallbacks.onLineRequestUnregisterFailed === "function")
            this.uiCallbacks.onLineRequestUnregisterFailed(message, this.sipserver, this.username);
    }
    onLineRegisterRequested() {
        if (typeof this.uiCallbacks.onLineRegisterRequested === "function")
            this.uiCallbacks.onLineRegisterRequested(this.sipserver, this.username);
    }
    onLineUnregisterRequested() {
        if (typeof this.uiCallbacks.onLineUnregisterRequested === "function")
            this.uiCallbacks.onLineUnregisterRequested(this.sipserver, this.username);
    }
    onRegistrationError(message) {
        this.displayName = undefined;
        this.registerStatus = 'unregistered';
        this.registerStatusError = message;
        for (let call of this.calls) {
            call.onLineUnregistered();
        }
        for (let call of this.bgCalls) {
            call.onLineUnregistered();
        }
        if (this.srCall) this.srCall.onLineUnregistered();
        if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function")
            this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
    }
    onRegistrationTrying() {
        this.registerStatus = 'registering';
        if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function")
            this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);

    }
    onUnregistrationTrying() {
        this.registerStatus = 'unregistering';
        for (let call of this.calls) {
            call.onLineUnregistered();
            this.onCallStatusChange(call.instanceId);
        }
        for (let call of this.bgCalls) {
            call.onLineUnregistered();
            this.onCallStatusChange(call.instanceId);
        }
        if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function")
            this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
    }
    onUnregistered() {
        this.displayName = undefined;
        this.registerStatus = 'unregistered';
        this.registerStatusError = undefined;
        for (let call of this.calls) {
            call.onLineUnregistered();
            this.onCallStatusChange(call.instanceId);
        }
        for (let call of this.bgCalls) {
            call.onLineUnregistered();
            this.onCallStatusChange(call.instanceId);
        }
        if (this.srCall) this.srCall.onLineUnregistered();
        this.canSrStart = false;
        this.canSrStop = this.srRequested;
        if (this.srCall) this.onCallStatusChange(this.srCall.instanceId);
    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function")
            this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
    }
    onRegistered(displayName) {
        this.displayName = displayName;
        this.registerStatus = 'registered';
        this.registerStatusError = undefined;
        for (let call of this.calls) {
            call.onLineRegistered();
            this.onCallStatusChange(call.instanceId);
        }
        for (let call of this.bgCalls) {
            call.onLineRegistered();
            this.onCallStatusChange(call.instanceId);
        }
        if (this.srCall) this.srCall.onLineRegistered();
        this.canSrStart = !this.srRequested;
        this.canSrStop = false;
        if (this.srCall) this.onCallStatusChange(this.srCall.instanceId);
        if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function")
            this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
    }
    onMwiStatusChange(on) {
        this.mwiStatus = on;
        if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function")
            this.uiCallbacks.onMwiStatusChange(this.sipserver, this.username);
    }
    onPendingCallCanceled(callId) {
        if (typeof this.uiCallbacks.onPendingCallCanceled === "function")
            this.uiCallbacks.onPendingCallCanceled(callId);
    }
    onCallStatusError(instanceId, errorCode, errorMessage) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (!call) {
            call = this.bgCalls.find(call => call.instanceId == instanceId);
        }
        if (!call && this.srCall && instanceId == this.srCall.instanceId) {
            call = this.srCall
        }
        if (call) { 
            call.onCallStatusError(errorCode, errorMessage);
        } else {
            Janus.error("Call instanceId:", instanceId, " not found");
        }
    }
    // Line call status
    onCallStatusIdle(instanceId, code, reason) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (!call) {
            call = this.bgCalls.find(call => call.instanceId == instanceId);
        } 
        if (!call && this.srCall && instanceId === this.srCall.instanceId) {
            call = this.srCall;
            this.canSrStart = true;
            this.canSrStop = false;
        }
        if (call) {
            call.onCallStatusIdle(code, reason);
        }
        this.onCallStatusChange(instanceId, 'idle');
    }
    onCallStatusDeepIdle(instanceId) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (!call) {
            call = this.bgCalls.find(call => call.instanceId == instanceId);
        }
        if (!call && this.srCall && instanceId === this.srCall.instanceId) {
            call = this.srCall;
        }
        if (call) {
            call.onCallStatusDeepIdle();
        }
        this.onCallStatusChange(instanceId);
    }

    onCallStatusChange(instanceId, callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
        let oldState = 'idle';
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (!call) {
            call = this.bgCalls.find(call => call.instanceId == instanceId);
        }
        if (!call && this.srCall && instanceId === this.srCall.instanceId) {
            call = this.srCall;
            call.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
            return;
        }
        if (call) {
            oldState = call.state;
            call.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
        } else {
            Janus.error("Call instanceId:", instanceId, " not found");
            return;
        }

        if (instanceId === this.srCall) return;


        // re-arrange
        if (this.calls[0].state === 'idle' && this.calls[1].state !== 'idle') {
            let callTemp = this.calls[0];
            this.calls[0] = this.calls[1];
            this.calls[1] = callTemp;
            this.callIndex = 0;
        }

        let fgIdleCallIndex = this.calls.findIndex(call => call.state === 'idle');
        if (fgIdleCallIndex >= 0) {
            // both foreground call are idle
            let bgActiveCallIndex = this.bgCalls.findIndex(call => call.state !== 'idle');
            if (bgActiveCallIndex >= 0) {
                let callTemp = this.calls[fgIdleCallIndex];
                this.calls[fgIdleCallIndex] = this.bgCalls[bgActiveCallIndex];
                this.bgCalls[bgActiveCallIndex] = callTemp;

                fgIdleCallIndex = this.calls.findIndex(call => call.state === 'idle');
                bgActiveCallIndex = this.bgCalls.findIndex(call => call.state !== 'idle');
                if (bgActiveCallIndex >= 0) {
                    let callTemp = this.calls[fgIdleCallIndex];
                    this.calls[fgIdleCallIndex] = this.bgCalls[bgActiveCallIndex];
                    this.bgCalls[bgActiveCallIndex] = callTemp;
                }
            }
        }

        let isCallConnected = [
            this.calls[0].state === 'hold' || this.calls[0].state === 'connected' || this.calls[0].state === 'reconnected',
            this.calls[1].state === 'hold' || this.calls[1].state === 'connected' || this.calls[1].state === 'reconnected',
        ];

        this.canToogle = this.pbxPlatform !== 'cucm' &&
            ((this.callIndex === 0 && isCallConnected[0]) ||
                (this.callIndex === 1 && (isCallConnected[1] || this.calls[1].state === 'idle')));

        this.calls[0].canXfer = false;
        this.calls[0].xferInstanceId = undefined;
        this.calls[1].canXfer = false;
        this.calls[1].xferInstanceId = undefined;
        if (this.calls[0].state !== 'idle' && this.calls[1].state !== 'idle') {
            if (isCallConnected[0]) {

                if (this.calls[1].state === 'callingOut' ||
                    this.calls[1].state === 'progressOut' ||
                    this.calls[1].state === 'ringingOut' ||
                    this.calls[1].state === 'hold' ||
                    this.calls[1].state === 'connected' ||
                    this.calls[1].state === 'reconnected') {
                    // 1 - can complete xfer, self is replaces
                    this.calls[1].canXfer = true;
                    this.calls[1].xferInstanceId = this.calls[0].instanceId;
                }
            }
            if (isCallConnected[1]) {

                if (this.calls[0].state === 'callingOut' ||
                    this.calls[0].state === 'progressOut' ||
                    this.calls[0].state === 'ringingOut' ||
                    this.calls[0].state === 'hold' ||
                    this.calls[0].state === 'connected' ||
                    this.calls[0].state === 'reconnected') {
                    // 1 - can complete xfer, self is replaces
                    this.calls[0].canXfer = this.pbxPlatform !== 'cucm' && true;
                    this.calls[0].xferInstanceId = this.calls[0].instanceId;
                }
            }
        } else if (this.calls[0].state === 'idle' && this.calls[1].state === 'idle') {
            // all calls are idle
            this.callIndex = 0;
            this.canToogle = false;
        }

        if (this.calls[0].state == 'incomingcallReplaces' || this.calls[0].state == 'callingOut') this.callIndex = 0;
        else if (this.calls[1].state == 'incomingcallReplaces' || this.calls[1].state == 'callingOut') this.callIndex = 1;

        if (oldState !== call.state && (call.state === 'connected' || call.state === 'reconnected')) {
            this.doMaintainCallFocus();
        }

        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
    onCallIdUpdate(instanceId, callId) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (call) {
            call.callId = callId;
        }
    }
    onMediaStatusChange(instanceId, event, stream) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (call) {
            if (event === 'localstream') {
                call.onLocalStream(stream, stream.active);
            } else if (event === 'remotestream') {
                call.onRemoteStream(stream, stream.active);
            }
        } else if (this.srCall &&  instanceId === this.srCall.instanceId) {
            if (event === 'localstream') {
                this.srCall.onLocalStream(stream, stream.active);
            } else if (event === 'remotestream') {
                this.srCall.onRemoteStream(stream, stream.active);
            }
        }
    }
    onStatsUpdated(instanceId, stats) {
        // stats is RTCStatsReport
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (call) {
            call.onStatsUpdated(stats)
        } else if (this.srCall && instanceId === this.srCall.instanceId) {
            this.srCall.onStatsUpdated(stats);
        }
    }

    onSlowLink(instanceId, uplink, media, lost) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (call) {
            call.onSlowLink(uplink, media, lost)
        } else if (this.srCall && instanceId === this.srCall.instanceId) {
            this.srCall.onSlowLink(uplink, media, lost);
        }
    }

    onReferHandled(instanceId, referInstanceId) {
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (call) {
            call.referInstanceId = referInstanceId;
            Janus.log("Call instanceId:", instanceId, " has handled REFER, REFER dial is by instance: ", referInstanceId);
        }
    }
};

export class SmLineView extends LineView {
    smTarget = undefined;

    constructor(smTarget) {
        super();
        this.smTarget = smTarget;
    }

    doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight) {
    }

    doStopScreenRecording() {
    }

    doRequestRegister() {
        if (!this.canRequestRegister || this.autoregister) {
            setTimeout(() => this.onLineRequestRegisterFailed("Cannot request register "), 0);
            return;
        }
        this.canRequestRegister = false;
        this.canRequestUnregister = false;
        try {
            JanusActivateSipRegistration(true, this.sipserver, this.username, this.secret, this.is_ha1_secret, this.displayName, this.smTarget);
            this.canRequestUnregister = true;
            setTimeout(() => this.onLineRegisterRequested(), 0);
        } catch (error) {
            this.canRequestRegister = true;
            setTimeout(() => this.onLineRequestRegisterFailed(error.message), 0);
        }
    }

    doToogle() {
        setTimeout(() => this.onCallStatusError(this.callIndex, CallStatusErrorCode.ERROR_TOGGLE_CALL, "Unable to alternate call"), 0);
        return;
    }

    doMaintainCallFocus() {
        this.callIndex = 0;
        this.canToogle = false;
    }

    onCallStatusChange(instanceId, callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
        let oldState = 'idle';
        let call = this.calls.find(call => call.instanceId == instanceId);
        if (call) {
            oldState = call.state;
            call.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
        } else {
            Janus.error("Call instanceId:", instanceId, " not found");
            return;
        }

        this.callIndex = 0;
        this.canToogle = false;
        if (typeof this.uiCallbacks.onCallStatusChange === "function")
            this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
    }
}

// endpointView:
//      // UI status
//		canConnect:		true/false,
//		canDisconnect:	true/false,
//
//		// commands
//		connect(janusServerUri):	connect to janus server where janusServerUri "https://your.janus.server.org:8089/janus,
//		disconnect():				disconnect from janus server
//	
//
//

var sessionService = null;

export class EndpointView {
    // private
    uiCallbacks = null;
    janusServerUri = undefined;
    autoregister = false;
    pbxPlatform = undefined;


    // public
    lineView = undefined;
    status = 'offline'; // offline; online; connecting
    statusError = undefined;
    // public caps
    canConnect = false;
    canDisconnect = false;

    // public
    init() {
        this.janusServerUri = undefined;
        this.lineView = undefined;
        this.status = 'offline';
        this.statusError = undefined;
        this.canConnect = true;
        this.canDisconnect = false;
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            setTimeout(() => this.uiCallbacks.onEndpointStatusChange(), 0);
    }

    //////////////////////////////////////////
    // UI commands
    //////////////////////////////////////////
    doConnectGuest(janusServerUri, turnServers, sipDomain, guestId, guestPasskey, pbxPlatformId, sipRealm, displayName) {
        this.doConnect(janusServerUri, sipDomain, "guest-" + Janus.randomString(6), "", turnServers, guestId, guestPasskey, true, null, null, null, pbxPlatformId, sipRealm, guestId, guestPasskey, displayName);
    }
    doConnect(janusServerUri, sipDomain, username, password, turnServers, turnUsername, turnPassword, autoregister, pushToken, alertPushToken, pushPlatformName, pbxPlatformId, sipRealm, janusServerUsername, janusServerPassword, displayName) {
        if (!this.canConnect) {
            Janus.error("Cannot connect");
            return;
        }


        if (this.lineView) {
            setTimeout(() => this.onEndpointConnectFailed("Line already added", sipserver, username), 0);
            return;
        }

        let pbxPlatform = undefined;
        if (!isNaN(parseInt(pbxPlatformId)) && parseInt(pbxPlatformId) === 3) {
            pbxPlatform = 'cucm';
        }
        let sipserver = "sip:" + (sipDomain ? sipDomain : "ipfx.pbx") + ":5060";

        if (username.length === 0) {
            setTimeout(() => this.onEndpointConnectFailed("Invalid username", sipserver, username), 0);
            return;
        }


        this.autoregister = autoregister;
        this.canConnect = false;
        this.canDisconnect = false;
        try {
            this.janusServerUri = janusServerUri;
            // Make sure the browser supports WebRTC
            if (!Janus.isWebrtcSupported()) {
                setTimeout(() => this.onEndpointConnectFailed("No WebRTC support... "), 0);
                return;
            }

            
            this.addLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, 'webrtc-recorder-sink');
            this.setupSessionService(janusServerUri, turnServers, turnUsername, turnPassword, autoregister, pushToken, alertPushToken, pushPlatformName, janusServerUsername, janusServerPassword, displayName, pbxPlatform);

        } catch (error) {
            this.lineView = undefined;
            setTimeout(() => this.onEndpointConnectFailed(error.message), 0);
        }
    }

    //////////////////////////////////////////
    doConnectScreenMonitor(janusServerUri, sipDomain, username, password, turnServers, turnUsername, turnPassword, pushPlatformName, pbxPlatformId, sipRealm, janusServerUsername, janusServerPassword, displayName, monitorTarget) {
        if (!this.canConnect) {
            Janus.error("Cannot connect screen monitor");
            return;
        }


        if (this.lineView) {
            setTimeout(() => this.onEndpointConnectFailed("Screen monitor line already added", sipserver, username), 0);
            return;
        }

        let pbxPlatform = undefined;
        if (isNaN(parseInt(pbxPlatformId)) && parseInt(pbxPlatformId) === 3) {
            pbxPlatform = 'cucm';
            setTimeout(() => this.onEndpointConnectFailed("Screen monitor not supported on CUCM platform", sipserver, username), 0);
            return;
        }

        let sipserver = "sip:" + (sipDomain ? sipDomain : "ipfx.pbx") + ":5060";

        if (!monitorTarget || monitorTarget.length === 0) {
            setTimeout(() => this.onEndpointConnectFailed("Invalid monitor target", sipserver, username), 0);
            return;
        }

        if (username.length === 0) {
            setTimeout(() => this.onEndpointConnectFailed("Invalid username", sipserver, username), 0);
            return;
        }


        this.autoregister = true;
        this.canConnect = false;
        this.canDisconnect = false;
        try {
            this.janusServerUri = janusServerUri;
            // Make sure the browser supports WebRTC
            if (!Janus.isWebrtcSupported()) {
                setTimeout(() => this.onEndpointConnectFailed("No WebRTC support... "), 0);
                return;
            }

            
            this.addScreenMonitorLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, monitorTarget);
            this.setupSessionService(janusServerUri, turnServers, turnUsername, turnPassword, this.autoregister, undefined, undefined, pushPlatformName, janusServerUsername, janusServerPassword, displayName, pbxPlatform, monitorTarget);

        } catch (error) {
            this.lineView = undefined;
            setTimeout(() => this.onEndpointConnectFailed(error.message), 0);
        }
    }


    setupSessionService(janusServerUri, turnServers, turnUsername, turnPassword, autoregister, pushToken, alertPushToken, pushPlatformName, janusServerUsername, janusServerPassword, displayName, pbxPlatform, monitorTarget)
    {
        if (sessionService === null) {
            sessionService = interpret(janusSession);
            sessionService.onTransition(state => {
                if (state.history === undefined)
                    Janus.log("Machine session state change: ",
                        state.history,
                        "-->",
                        state.value,
                        ", event: ",
                        state.event);
                else
                    Janus.log("Machine session state change: ",
                        state.history.value,
                        "-->",
                        state.value,
                        ", event: ",
                        state.event);
            });
            sessionService.machine.context.endpointView = this;
            sessionService.start();
        } else {
            sessionService.machine.context.endpointView = this;
        }
        if (turnServers && turnServers.length > 0) {
            sessionService.send({
                type: 'DO_CONNECT',
                autoregister: autoregister,
                janusServer: janusServerUri,
                janusServerUsername: janusServerUsername,
                janusServerPassword: janusServerPassword,
                pushToken: pushToken,
                alertPushToken: alertPushToken,
                pushPlatformName: pushPlatformName,
                sipserver: this.lineView.sipserver,
                username: this.lineView.username,
                secret: this.lineView.secret,
                is_ha1_secret: this.lineView.is_ha1_secret,
                iceServers: [
                    {
                        'urls': turnServers,
                        'credential': turnPassword,
                        'username': turnUsername
                    },
                ],
                pbxPlatform: pbxPlatform,
                displayName: this.lineView.displayName,
                monitorTarget: monitorTarget

            });
        } else {
            sessionService.send({
                type: 'DO_CONNECT',
                autoregister: autoregister,
                janusServer: janusServerUri,
                janusServerUsername: janusServerUsername,
                janusServerPassword: janusServerPassword,
                pushToken: pushToken,
                alertPushToken: alertPushToken,
                pushPlatformName: pushPlatformName,
                sipserver: this.lineView.sipserver,
                username: this.lineView.username,
                secret: this.lineView.secret,
                is_ha1_secret: this.lineView.is_ha1_secret,
                pbxPlatform: pbxPlatform,
                displayName: this.lineView.displayName,
                monitorTarget: monitorTarget
            });
        }

    }



    //////////////////////////////////////////
    doDisconnect(removeToken) {
        if (!this.canDisconnect) {
            Janus.error("Cannot disconnect");
            return;
        }
        if (!this.lineView) {
            this.canConnect = true;
            this.canDisconnect = false;
            return;
        }
        this.canConnect = false;
        this.canDisconnect = false;
        try {
            this.removeLine(removeToken);
            if (sessionService !== null) {
                sessionService.send('DO_DISCONNECT');
            }
        } catch (error) {
            Janus.error("Failed to disconnect endpoint:", error.message);
        }
    }

    //////////////////////////////////////////
    addLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, srTarget) {
        this.pbxPlatform = pbxPlatform;
        this.lineView = new LineView();
        this.lineView.uiCallbacks = this.uiCallbacks;
        this.lineView.sipserver = sipserver;
        this.lineView.username = username;
        this.lineView.secret = sipRealm ? md5(this.lineView.username + ':' + sipRealm + ':' + password) : password;
        this.lineView.is_ha1_secret = sipRealm ? true : false;
        this.lineView.canRequestRegister = false;
        this.lineView.canRequestUnregister = false;
        this.lineView.calls = [new CallView(), new CallView()];
        this.lineView.autoregister = this.autoregister;
        this.lineView.pbxPlatform = pbxPlatform;
        this.lineView.displayName = displayName;
        let i = 0;
        for (let call of this.lineView.calls) {
            call.uiCallbacks = this.uiCallbacks;
            call.sipserver = sipserver;
            call.username = username;
            call.instanceId = i++;
            call.pbxPlatform = pbxPlatform;
        }
        this.lineView.bgCalls = [new CallView(), new CallView()];
        for (let call of this.lineView.bgCalls) {
            call.uiCallbacks = this.uiCallbacks;
            call.sipserver = sipserver;
            call.username = username;
            call.instanceId = i++;
            call.pbxPlatform = pbxPlatform;
        }        
        this.lineView.callIndex = 0;
        this.lineView.srCall = new SrCallView();
        this.lineView.srCall.srTarget = srTarget;
        this.srTarget = srTarget;
        this.lineView.srCall.srFrameRate = { ideal: 3 };
        if (this.srRequested) this.doStartScreenRecording();
        this.lineView.srCall.sipserver = sipserver;
        this.lineView.srCall.username = username;
        this.lineView.srCall.instanceId = i++;
        this.lineView.srCall.pbxPlatform = pbxPlatform;
    }

    //////////////////////////////////////////
    addScreenMonitorLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, smTarget) {
        this.pbxPlatform = pbxPlatform;
        this.lineView = new SmLineView(smTarget);
        this.lineView.uiCallbacks = this.uiCallbacks;
        this.lineView.sipserver = sipserver;
        this.lineView.username = username;
        this.lineView.secret = sipRealm ? md5(this.lineView.username + ':' + sipRealm + ':' + password) : password;
        this.lineView.is_ha1_secret = sipRealm ? true : false;
        this.lineView.canRequestRegister = false;
        this.lineView.canRequestUnregister = false;
        this.lineView.calls = [new SmCallView() ];
        this.lineView.autoregister = this.autoregister;
        this.lineView.pbxPlatform = pbxPlatform;
        this.lineView.displayName = displayName;
        let i = 0;
        for (let call of this.lineView.calls) {
            call.uiCallbacks = this.uiCallbacks;
            call.sipserver = sipserver;
            call.username = username;
            call.instanceId = i++;
            call.pbxPlatform = pbxPlatform;
        }
        this.lineView.bgCalls = [];
        this.lineView.callIndex = 0;
        this.lineView.srCall = undefined;
    }
    //////////////////////////////////////////
    removeLine(removeToken) {
        let lineView = this.lineView;
        this.lineView = undefined;
        if (lineView) {
            try {
                lineView.canRequestUnregister = false;
                JanusDeactivateSipRegistration(removeToken);
            } catch (error1) {
                Janus.warn("Failed to unregister:", error1.message);
            }
            for (let call of lineView.calls) {
                try {
                    JanusHangupCall(call.instanceId);
                } catch (error1) {
                    Janus.warn("Failed to hangup call:", call.instanceId, ": ", error1.message);
                }
            }
            for (let call of lineView.bgCalls) {
                try {
                    JanusHangupCall(call.instanceId);
                } catch (error1) {
                    Janus.warn("Failed to hangup call:", call.instanceId, ": ", error1.message);
                }
            }
        }
    }

    ///////////////////////////////////////////
    // callbacks
    ///////////////////////////////////////////
    onEndpointConnectFailed(message) {
        Janus.warn("Failed to connect endpoint: ", message);
        this.status = 'offline';
        this.statusError = message;
        this.canConnect = true;
        this.canDisconnect = false;
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            this.uiCallbacks.onEndpointStatusChange();
    }
    onEndpointDisconnected(message) {
        Janus.log("Endpoint disconnected");
        this.status = 'offline';
        this.statusError = message;
        this.canConnect = true;
        this.canDisconnect = false;
        let lineViewCopy = this.lineView;
        this.lineView = undefined;
        if (lineViewCopy && typeof this.uiCallbacks.onEndpointLineRemoved === "function")
            setTimeout(() => this.uiCallbacks.onEndpointLineRemoved(lineViewCopy.sipserver, lineViewCopy.username), 0);
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            setTimeout(() => this.uiCallbacks.onEndpointStatusChange(), 0);
    }
    onEndpointReconnecting() {
        // Reconnecting will see the client state momentarily going through online->offline->online.
        // Client can still initiate connect or disconnect during the reconnection
        Janus.log("Endpoint now reconnecting to a another server");
        this.status = 'offline';
        this.statusError = undefined;
        this.canConnect = false;
        this.canDisconnect = true; // can still interrupt reconnecting process
        this.lineView.onEndpointReconnecting();
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            setTimeout(() => this.uiCallbacks.onEndpointStatusChange(), 0);
    }

    ///////////////////////////////////////////
    onEndpointConnecting() {
        Janus.log("Endpoint connecting...");
        this.status = 'connecting';
        this.statusError = undefined;
        this.canConnect = false;
        this.canDisconnect = false;
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            setTimeout(() => this.uiCallbacks.onEndpointStatusChange(), 0);
    }
    ///////////////////////////////////////////
    onEndpointConnected() {
        Janus.log("Endpoint connected");
        this.status = 'online';
        this.statusError = undefined;
        this.canConnect = false;
        this.canDisconnect = true;
        this.lineView.onEndpointConnected();
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            setTimeout(() => this.uiCallbacks.onEndpointStatusChange(), 0);
    }
    ///////////////////////////////////////////
    onEndpointRemoveLineFailed(message, sipserver, username) {
        Janus.warn("Endpoint remove failed:", message);
        this.canConnect = false;
        this.canDisconnect = this.status === 'online';
        if (typeof this.uiCallbacks.onEndpointStatusChange === "function")
            this.uiCallbacks.onEndpointRemoveLineFailed(message, sipserver, username);
    }
    ///////////////////////////////////////////
    onEndpointLineRemoved(sipserver, username) {
        Janus.log("Endpoint line removed:");
        this.canConnect = this.status === 'online';
        this.canDisconnect = false;
        if (typeof this.uiCallbacks.onEndpointLineAdded === "function")
            this.uiCallbacks.onEndpointLineRemoved(sipserver, username);
    }
};


////////////////////////////////////////////////////////////////////////
export function CreateEndpointView(uiCallbacks) {
    endpointView = new EndpointView();
    endpointView.uiCallbacks = uiCallbacks;
    window.endpointView = endpointView
    window.janusSession = janusSession
    return endpointView;
}




////////////////////////////////////////////////////////////////////////////////////
const janusSession = Machine({
    id: 'ipfxJanusSession',
    initial: 'inactive',
    context: {
        janusSession: null,
        janusServer: null,
        janusServerUsername: undefined,
        janusServerPassword: undefined,
        queuedStop: false,
        error: "",
        sipserver: "",
        username: "",
        secret: "",
        is_ha1_secret: false,
        idlePlugins: new Set([0, 1, 2, 3]),
        idleSrPlugins: new Set([4]),
        endpointView: null,
        autoregister: false,
        pushToken: null,
        alertPushToken: null,
        pushPlatformName: null,
        pbxPlatform: null,
        displayName: undefined,
        serverRequestToReconnect: false,
        iceServers: undefined,
        monitorTarget: undefined,
        isMonitorSession: false
    },
    on: {
        DO_CONNECT: { actions: () => { endpointView.onEndpointConnectFailed("Session machine in the wrong state for DO_CONNECT request") } },
        DO_DISCONNECT: { actions: assign({ queuedStop: () => true }) },
    },
    states: {
        inactive: {
            entry: 'onJanusSessionStoppedAction',
            on: {
                DO_CONNECT: {
                    target: 'pending',
                    actions: assign({
                        autoregister: (context, event) => event.autoregister,
                        janusServer: (context, event) => event.janusServer,
                        janusServerUsername: (context, event) => event.janusServerUsername,
                        janusServerPassword: (context, event) => event.janusServerPassword,
                        pushToken: (context, event) => event.pushToken,
                        alertPushToken: (context, event) => event.alertPushToken,
                        pushPlatformName: (context, event) => event.pushPlatformName,
                        sipserver: (context, event) => event.sipserver,
                        username: (context, event) => event.sipserver.replace("sip:", "sip:" + event.username + "@"),
                        secret: (context, event) => event.secret,
                        is_ha1_secret: (context, event) => event.is_ha1_secret,
                        pbxPlatform: (context, event) => event.pbxPlatform,
                        displayName: (context, event) => event.displayName,
                        iceServers: (context, event) => event.iceServers,
                        monitorTarget: (context, event) => event.monitorTarget,
                        isMonitorSession: (context, event) => event.monitorTarget != undefined,
                    })
                },
            }
        },
        reconnecting: {
            after: { 15000: 'inactive' }, // if we are stuck in reconnecting - bail out
            entry: ['onJanusSessionReconnectingAction', 'stopJanusSessionAction'],
            on: {
                DO_DISCONNECT: 'inactive',
                DO_RECONNECT: 'pending', // use saved context set by DO_CONNECT event
                DO_CONNECT: {
                    actions: assign({
                        autoregister: (context, event) => event.autoregister,
                        janusServer: (context, event) => event.janusServer,
                        janusServerUsername: (context, event) => event.janusServerUsername,
                        janusServerPassword: (context, event) => event.janusServerPassword,
                        pushToken: (context, event) => event.pushToken,
                        alertPushToken: (context, event) => event.alertPushToken,
                        pushPlatformName: (context, event) => event.pushPlatformName,
                        sipserver: (context, event) => event.sipserver,
                        username: (context, event) => event.sipserver.replace("sip:", "sip:" + event.username + "@"),
                        secret: (context, event) => event.secret,
                        is_ha1_secret: (context, event) => event.is_ha1_secret,
                        pbxPlatform: (context, event) => event.pbxPlatform,
                        displayName: (context, event) => event.displayName,
                        iceServers: (context, event) => event.iceServers,
                        monitorTarget: (context, event) => event.monitorTarget,
                        isMonitorSession: (context, event) => event.monitorTarget != undefined,
                    })
                },
                JANUS_SESSION_ERROR: 'pending',
                JANUS_SESSION_DESTROYED: 'pending',

            }
        },
        pending: {
            invoke: {
                id: 'sessionControl',
                src: 'sessionControlService'
            },
            entry: assign({ opaqueSessionId: () => Janus.randomString(12) }),
            exit: assign({ serverRequestToReconnect: () => false }),
            on: {
                JANUS_SESSION_SUCCESS: [
                    {
                        cond: (context, event) => context.queuedStop,
                        actions: 'stopJanusSessionAction'
                    },
                    {
                        cond: (context, event) => context.serverRequestToReconnect,
                        target: 'reconnecting'
                    },
                    {
                        target: 'active',
                    }
                ],
                JANUS_SESSION_PROGRESS: { actions: () => { endpointView.onEndpointConnecting() } },
                JANUS_SESSION_ERROR: {
                    target: 'inactive',
                    actions: 'onJanusSessionErrorAction'
                },
                JANUS_SESSION_DESTROYED: 'inactive',
                REQUEST_TO_RECONNECT: { actions: assign({ serverRequestToReconnect: () => true }) },
            }
        },
        active: {
            initial: 'connected',
            states: {
                disconnecting: {
                    entry: choose([
                        {
                            cond: context => !context.isMonitorSession,
                            actions: [
                                send('DETACH', { to: 'masterPlugin' }),
                                send('DETACH', { to: 'helperPlugin1' }),
                                send('DETACH', { to: 'helperPlugin2' }),
                                send('DETACH', { to: 'helperPlugin3' }),
                                send('DETACH', { to: 'srPlugin' }),
                            ]
                        },
                        {
                            cond: context => context.isMonitorSession,
                            actions: [
                                send('DETACH', { to: 'masterPlugin' }),
                            ]
                        }
                    ]),
                    after: { 4000: { target: 'destroying_session' } },
                },
                destroying_session: {
                    after: { 2000: 'destroying_session_expired' },
                    entry: 'stopJanusSessionAction'
                },
                destroying_session_expired: {
                    entry: send('JANUS_SESSION_DESTROYED')
                },
                connected: {
                    on: {
                        DO_DISCONNECT: 'disconnecting',
                    },
                },
            },
            invoke: [
                {
                    id: 'masterPlugin',
                    src: sipPluginSession,
                    onError: { target: '.destroying_session' },
                    data: {
                        sessionService: (context, event) => sessionService,
                        janusSession: (context, event) => context.janusSession,
                        opaqueId: (context, event) => "janus-sip-plugin-" + context.opaqueSessionId,
                        instanceId: 0,
                        autoregister: (context, event) => context.autoregister,
                        pushToken: (context, event) => context.pushToken,
                        alertPushToken: (context, event) => context.alertPushToken,
                        pushPlatformName: (context, event) => context.pushPlatformName,
                        registerSipserver: (context, event) => context.sipserver,
                        registerUsername: (context, event) => context.username,
                        registerSecret: (context, event) => context.secret,
                        registerIsHa1Secret: (context, event) => context.is_ha1_secret,
                        pbxPlatform: (context, event) => context.pbxPlatform,
                        registerDisplayname: (context, event) => context.displayName,
                        monitorTarget: (context, event) => context.monitorTarget,
                        disabledPlugin: () => false
                    },
                    onDone: { target: '.destroying_session', cond: (context) => context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1 }

                },
                {
                    id: 'helperPlugin1',
                    src: sipPluginSession,
                    onError: { target: '.destroying_session', cond: (context) => !context.isMonitorSession },
                    data: {
                        sessionService: (context, event) => sessionService,
                        janusSession: (context, event) => context.janusSession,
                        opaqueId: (context, event) => "janus-helper-sip-plugin-1-" + context.opaqueSessionId,
                        instanceId: 1,
                        pbxPlatform: (context, event) => context.pbxPlatform,
                        disabledPlugin: (context, event) => context.isMonitorSession
                    },
                    onDone: { target: '.destroying_session', cond: (context) => !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1}
                },
                {
                    id: 'helperPlugin2',
                    src: sipPluginSession,
                    onError: { target: '.destroying_session', cond: (context) => !context.isMonitorSession },
                    data: {
                        sessionService: (context, event) => sessionService,
                        janusSession: (context, event) => context.janusSession,
                        opaqueId: (context, event) => "janus-helper-sip-plugin-2-" + context.opaqueSessionId,
                        instanceId: 2,
                        pbxPlatform: (context, event) => context.pbxPlatform,
                        disabledPlugin: (context, event) => context.isMonitorSession
                    },
                    onDone: { target: '.destroying_session', cond: (context) => !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1}
                },
                {
                    id: 'helperPlugin3',
                    src: sipPluginSession,
                    onError: { target: '.destroying_session', cond: (context) => !context.isMonitorSession },
                    data: {
                        sessionService: (context, event) => sessionService,
                        janusSession: (context, event) => context.janusSession,
                        opaqueId: (context, event) => "janus-helper-sip-plugin-3-" + context.opaqueSessionId,
                        instanceId: 3,
                        pbxPlatform: (context, event) => context.pbxPlatform,
                        disabledPlugin: (context, event) => context.isMonitorSession
                    },
                    onDone: { target: '.destroying_session', cond: (context) => !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1}
                },
                {
                    id: 'srPlugin',
                    src: sipPluginSession,
                    onError: { target: '.destroying_session', cond: (context) => !context.isMonitorSession },
                    data: {
                        sessionService: (context, event) => sessionService,
                        janusSession: (context, event) => context.janusSession,
                        opaqueId: (context, event) => "janus-helper-sr-plugin-" + context.opaqueSessionId,
                        instanceId: 4,
                        pbxPlatform: (context, event) => context.pbxPlatform,
                        disabledPlugin: (context, event) => context.isMonitorSession
                    },
                    onDone: { target: '.destroying_session', cond: (context) => !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1 }
                }
            ],
            entry: 'onJanusSessionStartedAction',
            exit: assign({ serverRequestToReconnect: () => false }),
            on: {
                JANUS_SESSION_DESTROYED: 'inactive',
                JANUS_SESSION_ERROR: {
                    actions: [
                        send((context, event) => ({ type: 'JANUS_SESSION_ENDED' }), { to: 'masterPlugin' }),
                        send((context, event) => ({ type: 'JANUS_SESSION_ENDED' }), { to: 'helperPlugin1' }),
                        send((context, event) => ({ type: 'JANUS_SESSION_ENDED' }), { to: 'helperPlugin2' }),
                        send((context, event) => ({ type: 'JANUS_SESSION_ENDED' }), { to: 'helperPlugin3' }),
                        send((context, event) => ({ type: 'JANUS_SESSION_ENDED' }), { to: 'srPlugin' }),
                    ]
                },
                PLUGIN_REGISTRATION_FAILED: { actions: 'notifyRegistrationFailedAction', cond: (context, event) => event.instanceId == 0 },
                PLUGIN_RETRYING_REGISTER: { actions: 'notifyRetryingRegistrationAction', cond: (context, event) => event.instanceId == 0 },
                PLUGIN_TRYING_UNREGISTER: { actions: 'notifyTryingUnregistrationAction', cond: (context, event) => event.instanceId == 0 },
                PLUGIN_UNREGISTERED: { actions: 'notifyUnregisteredAction', cond: (context, event) => event.instanceId == 0 },
                PLUGIN_REGISTERED: {
                    actions: [
                        'notifyRegisteredAction',
                        send((context, event) => ({
                            type: 'ATTACH',
                            masterId: event.masterId,
                            registerUsername: event.registerUsername
                        }), { to: 'helperPlugin1' }),
                        send((context, event) => ({
                            type: 'ATTACH',
                            masterId: event.masterId,
                            registerUsername: event.registerUsername
                        }), { to: 'helperPlugin2' }),
                        send((context, event) => ({
                            type: 'ATTACH',
                            masterId: event.masterId,
                            registerUsername: event.registerUsername
                        }), { to: 'helperPlugin3' }),
                        send((context, event) => ({
                            type: 'ATTACH',
                            masterId: event.masterId,
                            registerUsername: event.registerUsername
                        }), { to: 'srPlugin' }),
                        send((context, event) => ({
                            type: 'SUBSCRIBE',
                        }), { to: 'masterPlugin' }),
                    ],
                    cond: (context, event) => event.instanceId == 0 && !context.isMonitorSession
                },
                CTI_MWI: { actions: 'notifyMwiAction' },
                CANCEL_PENDING_CALL: { actions: 'cancelPendingCallAction' },
                CTI_HOLD: { actions: send((context, event) => ({ type: 'FORWARD_TO_PLUGIN', event: { type: 'DO_HOLD', instanceId: event.instanceId } })) },
                CTI_ANSWER: { actions: send((context, event) => ({ type: 'FORWARD_TO_PLUGIN', event: { type: 'DO_ACCEPT', instanceId: event.instanceId } })) },
                CTI_RESUME: { actions: send((context, event) => ({ type: 'FORWARD_TO_PLUGIN', event: { type: 'DO_RESUME', instanceId: event.instanceId } })) },
                CTI_DIAL: [
                    {
                        actions: send((context, event) => ({ type: 'FORWARD_TO_PLUGIN', event: { type: 'DO_MAKE_CALL', target: event.dialUri, referId: "", instanceId: Array.from(context.idlePlugins).sort((a, b) => a - b)[0] } })),
                        cond: (context) => context.idlePlugins.size > 0
                    },
                    { target: undefined },// consume
                ],
                START_CAPTURE: { actions: 'notifyStartMediaCapture'},
                STOP_CAPTURE: { actions: 'notifyStopMediaCapture'},
                SUSPEND_CAPTURE: { actions: 'notifySuspendMediaCapture'},
                RESUME_CAPTURE: { actions: 'notifyResumeMediaCapture'},
                CALL_STATE_ERROR: { actions: 'notifyCallStateErrorAction' },
                DO_REGISTER: { actions: [assign({ sipserver: (context, event) => event.sipserver }), forwardTo('masterPlugin')] },
                DO_UNREGISTER: { actions: [send((context, event) => ({ type: 'UNSUBSCRIBE', removeToken: event.removeToken }), { to: 'masterPlugin' }), forwardTo('masterPlugin')] },
                // call commands
                FORWARD_TO_PLUGIN: [
                    { actions: send((context, event) => event.event, { to: 'masterPlugin' }), cond: (context, event) => event.event.instanceId == 0 },
                    { actions: send((context, event) => event.event, { to: 'helperPlugin1' }), cond: (context, event) => event.event.instanceId == 1 },
                    { actions: send((context, event) => event.event, { to: 'helperPlugin2' }), cond: (context, event) => event.event.instanceId == 2 },
                    { actions: send((context, event) => event.event, { to: 'helperPlugin3' }), cond: (context, event) => event.event.instanceId == 3 },
                    { actions: send((context, event) => event.event, { to: 'srPlugin' }), cond: (context, event) => event.event.instanceId == 4 },
                ],
                // call states
                CALL_STATE_IDLE: {
                    actions: [
                        assign({ idlePlugins: (context, event) => event.instanceId < 4 ? context.idlePlugins.add(event.instanceId) : context.idlePlugins }),
                        assign({ idleSrPlugins: (context, event) => event.instanceId >= 4 ? context.idleSrPlugins.add(event.instanceId) : context.idleSrPlugins }),
                        'notifyCallStateIdleAction'
                    ]
                },
                CALL_STATE_DEEP_IDLE: [
                    {
                        // make sure all calls are idle
                        target: 'reconnecting',
                        cond: 'canReconnect'
                    },
                    {
                        actions: 'notifyCallStateDeepIdleAction'
                    },
                ],
                CALL_STATE_TRYING_OUT: { actions: ['setPluginBusyAction', 'notifyCallStateTryingOutAction'] },
                CALL_STATE_CALLING_OUT: { actions: 'notifyCallStateCallingOutAction' },
                CALL_STATE_RINGING_OUT: { actions: 'notifyCallStateRingingOutAction' },
                CALL_STATE_PROCEEDING_OUT: { actions: 'notifyCallStateProceedingOutAction' },
                CALL_STATE_PROGRESS_OUT: { actions: 'notifyCallStateProgressOutAction' },
                CALL_STATE_CONNECTING: { actions: 'notifyCallStateConnectingAction' },
                CALL_STATE_CONNECTED: { actions: 'notifyCallStateConnectedAction' },
                CALL_STATE_HANGINGUP: { actions: 'notifyCallStateHangingUpAction' },
                CALL_STATE_ONHOLD: { actions: 'notifyCallStateOnHoldAction' },
                CALL_STATE_INCOMING_CALL: { actions: ['setPluginBusyAction', 'handleCallStateIncomingCallAction'] },
                CALL_STATE_DO_XFERRING: { actions: 'handleCallStateXferringtAction' },
                HANDLE_REFER: { actions: 'handleReferAction' },
                DO_BLIND_XFER_FAILED: { actions: 'notifyBlindXferFailedAction' },
                DO_BLIND_XFER_SUCCEEDED: { actions: 'notifyBlindXferSucceededAction' },
                DO_XFER_FAILED: { actions: 'notifyXferFailedAction' },
                DO_XFER_SUCCEEDED: { actions: 'notifyXferSucceededAction' },
                // media
                MEDIA_ON_LOCAL_STREAM: { actions: 'notifyMediaOnLocalStreamAction' },
                MEDIA_ON_REMOTE_STREAM: { actions: 'notifyMediaOnRemoteStreamAction' },
                SLOWLINK: { actions: 'notifySlowLinkAction' },
                ON_STATS_UPDATED: { actions: 'notifyOnStatsUpdatedAction' },
                REQUEST_TO_RECONNECT: [
                    {
                        // make sure all calls are idle
                        target: 'reconnecting',
                        cond: (context) => context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1
                    },
                    {
                        actions: assign({ serverRequestToReconnect: () => true }),
                        cond: (context) => context.idlePlugins.size < 4 ||  context.idleSrPlugins.size < 1
                    },
                ],
            },
        },

        destroyed: {
            always: 'inactive',
        }
    }
},
    {
        guards:
        {
            canReconnect: (context, event) => {
                return context.serverRequestToReconnect && context.idlePlugins.size == 4 &&  context.idleSrPlugins.size == 1;
            }
        },
        actions: {
            logEvent: (context, event) => {
                Janus.log("!!! Context: ", context);
                Janus.log("!!! Event: ", event);
            },
            onJanusSessionStoppedAction: (context, event) => {
                if (event.type === "xstate.init") return;
                context.endpointView.onEndpointDisconnected(event.message);
            },
            onJanusSessionReconnectingAction: (context, event) => {
                context.endpointView.onEndpointReconnecting();
            },
            onJanusSessionStartedAction: (context, event) => {
                let plugins = [];
                if (sessionService.state.children.masterPlugin !== undefined) plugins.push(sessionService.state.children.masterPlugin);
                if (sessionService.state.children.helperPlugin1 !== undefined) plugins.push(sessionService.state.children.helperPlugin1);
                if (sessionService.state.children.helperPlugin2 !== undefined) plugins.push(sessionService.state.children.helperPlugin2);
                if (sessionService.state.children.helperPlugin3 !== undefined) plugins.push(sessionService.state.children.helperPlugin3);
                if (sessionService.state.children.srPlugin !== undefined) plugins.push(sessionService.state.children.srPlugin);
                for (let plugin of plugins) {
                    let instanceId = plugin.state.context.instanceId;
                    if (plugin.listeners.size >= 4) break;
                    plugin.listeners.add(state => {
                        if (state.history === undefined)
                            Janus.log("Machine plugin(",
                                instanceId,
                                ") state change: ",
                                state.history,
                                "-->",
                                state.value,
                                ", event: ",
                                state.event);
                        else
                            Janus.log("Machine plugin(",
                                instanceId,
                                ") state change: ",
                                state.history.value,
                                "-->",
                                state.value,
                                ", event: ",
                                state.event);
                    });
                }
                context.endpointView.onEndpointConnected();
            },
            onJanusSessionErrorAction: (context, event) => {
                // nothing
            },
            stopJanusSessionAction: (context, event) => {
                context.janusSession.destroy();
            },
            onMasterPluginError: (context, error) => {

            },
            notifyRegistrationFailedAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onRegistrationError(event.error);
                }
            },
            notifyRetryingRegistrationAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onRegistrationTrying();
                }
            },
            notifyTryingUnregistrationAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onUnregistrationTrying();
                }
            },
            notifyUnregisteredAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onUnregistered();
                }
            },
            notifyRegisteredAction: (context, event) => {
                if (context.endpointView.lineView && event.instanceId == 0) {
                    context.endpointView.lineView.onRegistered(event.displayName);
                }
            },
            notifyMwiAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onMwiStatusChange(event.mwi);
                }
            },
            cancelPendingCallAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onPendingCallCanceled(event.callId);
                }
            },
            notifyCallStateErrorAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusError(event.instanceId, event.errorCode, event.errorMessage);
                }
            },
            notifyCallStateIdleAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusIdle(event.instanceId, event.code, event.reason);
                }
            },
            notifyCallStateDeepIdleAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusDeepIdle(event.instanceId);
                }
            },
            notifyCallStateTryingOutAction: (context, event) => {
            },
            notifyCallStateCallingOutAction: (context, event) => {
                if (context.endpointView.lineView) {
                    if (event.callId) context.endpointView.lineView.onCallIdUpdate(event.instanceId, event.callId);
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'callingOut', undefined, event.remoteUri);
                }
            },
            notifyCallStateRingingOutAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'ringingOut', undefined, event.remoteUri, event.remoteDisplay);
                }
            },
            notifyCallStateProceedingOutAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'ringingOut');
                }
            },
            notifyCallStateProgressOutAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'progressOut', undefined, event.remoteUri, event.remoteDisplay);
                }
            },
            notifyCallStateConnectingAction: (context, event) => {
            },

            notifyCallStateConnectedAction: (context, event) => {
                if (context.endpointView.lineView) {
                    let media_caps = {
                        hasLocalAudio: event.hasLocalAudio,
                        hasRemoteAudio: event.hasRemoteAudio,
                        hasLocalVideo: event.hasLocalVideo,
                        hasRemoteVideo: event.hasRemoteVideo,
                        enabledVideoSource: event.enabledVideoSource,
                    };
                    context.endpointView.lineView.onCallStatusChange(
                        event.instanceId,
                        event.isInitial ? 'connected' : 'reconnected',
                        undefined, // call state desc
                        event.remoteUri,
                        event.remoteDisplay,
                        media_caps
                    );
                }
            },
            notifyCallStateHangingUpAction: (context, event) => {
            },
            notifyCallStateOnHoldAction: (context, event) => {
                if (context.endpointView.lineView) {
                    let media_caps = {
                        hasLocalAudio: event.hasLocalAudio,
                        hasRemoteAudio: event.hasRemoteAudio,
                        hasLocalVideo: event.hasLocalVideo,
                        hasRemoteVideo: event.hasRemoteVideo,
                        enabledVideoSource: event.enabledVideoSource,
                    };
                    context.endpointView.lineView.onCallStatusChange(
                        event.instanceId,
                        'hold',
                        undefined, // call state desc
                        undefined, // remte uri
                        undefined, // remote display
                        media_caps
                    );
                }
            },
            setPluginBusyAction: (context, event) => {
                if (event.instanceId < 4) context.idlePlugins.delete(event.instanceId)
                else  context.idleSrPlugins.delete(event.instanceId);
            },
            handleCallStateIncomingCallAction: (context, event) => {
                if (event.replaces) {
                    // handle replaces without user input
                    Janus.log("Replaces incoming call, replaces sip-call-id", event.replaces);
                    let replaces_plugin = null;
                    let replacing_plugin = null;
                    for (let value of sessionService.children.values()) {
                        if (value.state.context.instanceId == event.instanceId) {
                            replacing_plugin = value;
                            break;
                        }
                    }

                    for (let value of sessionService.children.values()) {
                        if (value.state.children.callControl.state.context.sip_call_id === event.replaces) {
                            replaces_plugin = value;
                            break;
                        }
                    }

                    if (replaces_plugin !== null && replacing_plugin !== null) {
                        Janus.log("Replaces instance ID:", replaces_plugin.state.context.instanceId);
                        Janus.log("Replacing instance ID:", replacing_plugin.state.context.instanceId);
                        // answer replacing call and hangup replaces call
                        if (context.endpointView.lineView) {
                            context.endpointView.lineView.onCallStatusChange(event.instanceId, 'incomingcallReplaces', undefined, event.callerUsername, event.callerDisplay);
                            if (replaces_plugin.state.context.isCallAnswered) {
                                JanusAnswerCall(event.instanceId);
                                JanusHangupCall(replaces_plugin.state.context.instanceId);
                            } else {
                                //JanusHangupCall(replaces_plugin.state.context.instanceId);
                                if (event.callId) context.endpointView.lineView.onCallIdUpdate(event.instanceId, event.callId);
                            }
                        }
                    } else {
                        Janus.warn("Replaces call-id: ", event.replaces, " doesn't match other session call-id");
                        JanusDeclineCall(event.instanceId, 481);
                    }
                } else if (context.endpointView.lineView) {
                    if (event.callId) context.endpointView.lineView.onCallIdUpdate(event.instanceId, event.callId);
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'incomingcall', undefined, event.callerUsername, event.callerDisplay);
                }
            },
            notifyMediaOnLocalStreamAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onMediaStatusChange(event.instanceId, 'localstream', event.stream);
                }
            },
            notifyMediaOnRemoteStreamAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onMediaStatusChange(event.instanceId, 'remotestream', event.stream);
                }
            },
            notifyOnStatsUpdatedAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onStatsUpdated(event.instanceId, event.stats);
                }
            },
            notifySlowLinkAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onSlowLink(event.instanceId, event.uplink, event.media, event.lost);
                }
            },
            handleReferAction: (context, event) => {
                // find idle plugin
                let idleArr = Array.from(context.idlePlugins).sort((a, b) => a - b);
                if (event.instanceId < 4 && idleArr.length > 0) {
                    Janus.log("Refer dial to [", event.refer_event.result["refer_to"], "] is to be performed by plugin instance ", idleArr[0]);
                    sessionService.send({
                        type: 'FORWARD_TO_PLUGIN',
                        event: {
                            type: 'DO_MAKE_CALL',
                            target: event.refer_event.result["refer_to"],
                            referId: event.refer_event.result["refer_id"],
                            instanceId: idleArr[0]
                        }
                    });
                    context.endpointView.lineView.onReferHandled(event.instanceId, idleArr[0]);
                } else {
                    // reject REFER
                    sessionService.send({
                        type: 'FORWARD_TO_PLUGIN',
                        event: {
                            type: 'DO_REJECT_REFER',
                            instanceId: event.instanceId,
                            result: event.refer_event.result
                        }
                    });
                }
            },
            notifyBlindXferFailedAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusError(event.instanceId, CallStatusErrorCode.ERROR_TRANSFER, event.message);
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'blindtransferfailed');
                }
            },
            notifyXferFailedAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusError(event.instanceId, CallStatusErrorCode.ERROR_TRANSFER, event.message);
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'transferfailed');
                }
            },
            notifyBlindXferSucceededAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'blindtransferok');
                }
            },
            notifyXferSucceededAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'transferok');
                }
            },
            handleCallStateXferringtAction: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.onCallStatusChange(event.instanceId, 'transferring');
                }
            },
            notifyStartMediaCapture: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.doStartScreenRecording(event.target, event.callId, event.frameRate, event.screenWidth, event.screenHeight);
                }
            },
            notifyStopMediaCapture: (context, event) => {
                if (context.endpointView.lineView) {
                    context.endpointView.lineView.doStopScreenRecording();
                }
            },
            notifySuspendMediaCapture: (context, event) => {
                if (!context.endpointView.lineView.srCall) Janus.error('Unable to suspend screen recording (no call)')
                try {
                    sessionService.send({
                        type: 'FORWARD_TO_PLUGIN',
                        event: {
                            type: 'DO_HOLD',
                            instanceId: context.endpointView.lineView.srCall.instanceId,
                        }
                    });
                } catch (err) {
                    Janus.error('Unable to suspend screen recording', err)
                }        
            },
            notifyResumeMediaCapture: (context, event) => {
                if (!context.endpointView.lineView.srCall) Janus.error('Unable to resume screen recording (no call)')
                try {
                    sessionService.send({
                        type: 'FORWARD_TO_PLUGIN',
                        event: {
                            type: 'DO_RESUME',
                            instanceId: context.endpointView.lineView.srCall.instanceId,
                        }
                    });
                } catch (err) {
                    Janus.error('Unable to resume screen recording', err)
                }        
            },
        },
        // Services
        services: {
            sessionControlService: (context, event) => (callback, onReceive) => {
                try {
                    context.error = "";
                    context.queuedStop = false;
                    context.janusSession = new Janus({
                        server: context.janusServer,
                        janusServerUsername: context.janusServerUsername,
                        janusServerPassword: context.janusServerPassword,
                        iceServers: context.iceServers,
                        longPollTimeout: 60000,	// change that to 20000 once the janus service default is set to 15
                        success: () => {
                            Janus.log("Janus session created");
                            callback('JANUS_SESSION_SUCCESS');
                        },
                        error: (error) => {
                            Janus.error("Failed to create Janus session", error);
                            if (sessionService !== null) {
                                context.error = error.includes("network error") ? "Unable to connect due to a network error" : error;
                                try {
                                    sessionService.send({ type: 'JANUS_SESSION_ERROR', message: context.error });
                                } catch (error) {
                                    // don't care
                                    Janus.warn("Error while sending JANUS_SESSION_ERROR:", error.message);
                                }
                            }

                        },
                        destroyed: () => {
                            Janus.log("Janus session destroyed");
                            sessionService.send('JANUS_SESSION_DESTROYED');
                        }
                    });
                    callback('JANUS_SESSION_PROGRESS');
                } catch (error) {
                    callback({ type: 'JANUS_SESSION_ERROR', message: error.message });
                }
            },
        }
    }
);



function JanusActivateSipRegistration(on, sipserver, username, secret, is_ha1_secret, displayName, smTarget) {
    if (sessionService !== null && on) {
        sessionService.send({
            type: 'DO_REGISTER',
            sipserver: sipserver,
            username: username,
            secret: secret,
            is_ha1_secret: is_ha1_secret,
            displayName: displayName,
            smTarget: smTarget
        });
    } else if (!on) {
        sessionService.send('DO_UNREGISTER');
    }

}

function JanusDeactivateSipRegistration(removeToken) {
    sessionService.send({
        type: 'DO_UNREGISTER',
        removeToken: removeToken
    });
}



function JanusHangupCall(instanceId) {
    if (sessionService !== null) {
        sessionService.send({
            type: 'FORWARD_TO_PLUGIN',
            event: {
                type: 'DO_HANGUP',
                instanceId: instanceId
            }
        });
    }
}


function JanusAnswerCall(instanceId) {
    if (sessionService !== null) {
        sessionService.send({
            type: 'FORWARD_TO_PLUGIN',
            event: {
                type: 'DO_ACCEPT',
                instanceId: instanceId
            }
        });
    }
}

function JanusDeclineCall(instanceId, code) {
    if (sessionService !== null) {
        sessionService.send({
            type: 'FORWARD_TO_PLUGIN',
            event: {
                type: 'DO_DECLINE',
                instanceId: instanceId,
                code: code

            }
        });
    }
}

function JanusCompleteTransfer(instanceId) {
    if (sessionService !== null) {
        // determine replaces call-id
        let replaces_call_id = "";
        let refer_to = "";
        for (let value of sessionService.children.values()) {
            if (value.state.context.instanceId !== instanceId && !sessionService.state.context.idlePlugins.has(value.state.context.instanceId)) {
                replaces_call_id = value.state.children.callControl.state.context.sip_call_id;
                refer_to = value.state.children.callControl.state.context.remote_uri;
                break;
            }
        }
        if (!replaces_call_id || !refer_to) {
            sessionService.send({ type: 'XFER_FAILED', instanceId: instanceId, message: 'Consulation call not found' });
            return;
        }
        Janus.log("Completing transfer to [", refer_to, "], replaces-call-id [", replaces_call_id, "]");
        sessionService.send({
            type: 'FORWARD_TO_PLUGIN',
            event: {
                type: 'DO_XFER',
                instanceId: instanceId,
                refer_to: refer_to,
                replaces_call_id: replaces_call_id
            }
        });
    }
}

